<script>
    export let name = '';
    export let color = '';
    export let colorName = false;

    let nameColor = '';

    $: {
            nameColor = colorName ? `#${color}` : 'inherit';
    }
</script>

<span class="colored-name">
    <span class="color" style="background: #{color};"></span>
    <span class="name" style="color: {nameColor};">{ name }</span>
</span>

<style>
    .colored-name {
        display: flex;
        align-items: center;
    }

    .colored-name .color {
        width: 10px;
        height: 10px;
        border: 2px solid #fff;
        border-radius: 3px;
        margin-right: 4px;
    }
</style>